
<label>
  <ng-content></ng-content>

  <mat-slide-toggle
    color="primary"
    [formControl]="control"
    class="disable-form-error"
  ></mat-slide-toggle>
</label>
